import React, { useState } from "react";
import { FaUtensils, FaMotorcycle, FaGlassCheers } from "react-icons/fa";

const categories = [
  { name: "Dining Out", icon: <FaUtensils />, id: "tab-dining" },
  { name: "Delivery", icon: <FaMotorcycle />, id: "tab-delivery" },
  { name: "Nightlife", icon: <FaGlassCheers />, id: "tab-nightlife" },
];

export default function CategoryTabs() {
  const [active, setActive] = useState("Dining Out");

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "3rem",
      padding: "1.5rem 1rem",
      borderBottom: "1px solid #eee",
      flexWrap: "wrap",
    },
    tabItem: (isActive) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      cursor: "pointer",
      position: "relative",
      color: isActive ? "#e03546" : "#4f4f4f",
      fontWeight: isActive ? "600" : "500",
      transition: "color 0.3s ease",
    }),
    iconWrapper: (isActive) => ({
      backgroundColor: isActive ? "#e1f1f0" : "#f5f5f5",
      padding: isActive ? "10px" : "10px",
      borderRadius: "50%",
      marginBottom: "6px",
      width: "48px",
      height: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
    }),
    underline: {
      position: "absolute",
      bottom: "-8px",
      height: "3px",
      width: "100%",
      backgroundColor: "#e03546",
      borderRadius: "2px",
    },
    labelText: {
      fontSize: "14px",
    },
    // Responsive (manual approach)
    responsive: window.innerWidth <= 600 && {
      gap: "2rem",
    },
    iconResponsive: window.innerWidth <= 600 && {
      width: "40px",
      height: "40px",
      padding: "8px",
      fontSize: "18px",
    },
  };

  return (
    <div
      id="category-tabs"
      style={{ ...styles.container, ...styles.responsive }}
    >
      {categories.map((cat) => {
        const isActive = active === cat.name;
        return (
          <div
            key={cat.name}
            id={cat.id}
            style={styles.tabItem(isActive)}
            onClick={() => setActive(cat.name)}
          >
            <div
              style={{
                ...styles.iconWrapper(isActive),
                ...styles.iconResponsive,
              }}
            >
              {cat.icon}
            </div>
            <span style={styles.labelText}>{cat.name}</span>
            {isActive && <div style={styles.underline} />}
          </div>
        );
      })}
    </div>
  );
}
